import { Platform } from 'react-native';
import { N8nChatButton } from './n8nChat/N8nChatButton.web';
import { TChatButtonProps } from './ChatButton.types';

export const ChatButton = (props: TChatButtonProps) => {
  const ChatButtonComponent = Platform.OS === 'web' ? N8nChatButton : (props: TChatButtonProps) => null;
  return <ChatButtonComponent {...props} />;
};
